'use client';

import { Box, Container, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

import Link from '@/components/Link';
import Serwizz from '@/components/SvgIcons/Serwizz';
import colors from '@/styles/themes/colors';
import useBreakpoint from '@/utils/hooks/useBreakpoint';

import styles from './SerwizzSection.module.scss';

const SerwizzSection = () => {
  const t = useTranslations('home.serwizzSection');
  const { isMobile } = useBreakpoint();

  return (
    <Container component="section" maxWidth={false} disableGutters className={styles.container}>
      <Box className={styles.imageWrapper}>
        {isMobile ? (
          <Image src="/images/home/serwizz/banner-mobile.webp" alt="Hero background" fill priority sizes="100vw" />
        ) : (
          <Image src="/images/home/serwizz/banner.webp" alt="Hero background" fill priority sizes="100vw" />
        )}
      </Box>
      <Box className={styles.content}>
        <Serwizz />
        <Typography variant="h4" component="h2" color={colors.graytone950} textAlign="center">
          {t('title')}
        </Typography>
        <Typography variant="body1" color={colors.graytone600} className={styles.description} textAlign="center">
          {t('description')}
        </Typography>
        <Link href="/work/serwizz-cmms" text={t('linkText')} className={styles.link} />
      </Box>
    </Container>
  );
};

export default SerwizzSection;
